// components/FeaturedNews.js
import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Avatar,
  styled,
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import PersonIcon from '@mui/icons-material/Person';
import { Phone, Verified, Instagram } from '@mui/icons-material';
import GameZoneAvatar from '../assetts/icons/12.png';
import { IoPricetags } from 'react-icons/io5';
import halls from '../utils/halls';

function FeaturedNews() {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" gutterBottom align="center">
        Наши Залы
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {halls.map((hall, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: hall.grand
                  ? '0 8px 20px rgba(0,0,0,0.3)'
                  : '0 2px 5px rgba(0,0,0,0.1)',
                position: 'relative',
                textAlign: 'center',
                background: hall.grand
                  ? 'linear-gradient(135deg, #0b0210, #351900)'
                  : 'black',
                color: 'white',
              }}
            >
              <Swiper
                spaceBetween={10}
                slidesPerView={1}
                loop
                pagination={{ clickable: true }}
                style={{ borderRadius: '8px 8px 0 0' }}
              >
                {hall.images.map((image, imgIndex) => (
                  <SwiperSlide key={imgIndex}>
                    <Box
                      component="img"
                      src={image}
                      alt={hall.title}
                      sx={{
                        width: '100%',
                        height: '250px',
                        objectFit: 'cover',
                        borderRadius: imgIndex === 0 ? '8px 8px 0 0' : 'none',
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <CardContent>
                <Typography variant="body2" color="#676f73">
                  {hall.type}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {hall.title}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mb: 1 }}
                  >
                    <PersonIcon sx={{ color: '#4ba547', mr: 1 }} />
                    <Typography variant="body2" color="#fff">
                      {hall.capacity}
                    </Typography>
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mb: 2, gap: '0.5rem' }}
                  >
                    <IoPricetags
                      sx={{ color: '#fff', mr: 1 }}
                      fontSize="small"
                      color="#f20303"
                    />
                    <Typography variant="body2" color="#cacacaf1">
                      <b>{hall.price}</b>
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  {hall.description}
                </Typography>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  sx={{ mt: 2 }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.7rem',
                    }}
                  >
                    <Avatar
                      src={GameZoneAvatar}
                      alt="Game Zone Avatar"
                      sx={{ border: '1px solid #750fb4' }}
                    />
                    <Typography
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                      }}
                    >
                      Game Zone <Verified fontSize="small" color="primary" />
                    </Typography>
                  </div>
                  <div>
                    <Button
                      sx={{ color: 'green' }}
                      onClick={() =>
                        window.open(
                          'https://www.instagram.com/game.zone.kg/',
                          '_blank'
                        )
                      }
                    >
                      <Instagram sx={{ mr: 1 }} />
                    </Button>
                    <Button
                      sx={{ color: 'green' }}
                      onClick={() => window.open('tel:+996705130070')}
                    >
                      <Phone sx={{ mr: 1 }} />
                    </Button>
                  </div>
                </Box>
                <StyledButton
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    window.open(
                      `https://t.me/+996705130070?text=${encodeURIComponent(
                        `"Здрасте! Хотел забронировать зал для PS в ${hall.title}. Когда свободно и во сколько прийти?"`
                      )}`,
                      '_blank'
                    )
                  }
                  sx={{
                    mt: 2,
                    width: '100%',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                  }}
                >
                  Бронировать
                </StyledButton>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default FeaturedNews;

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
  fontWeight: 600,
  borderRadius: '10px',
  padding: theme.spacing(1, 1),
  textTransform: 'none',
  color: theme.palette.primary.contrastText,
  background: 'linear-gradient(135deg, #750fb4, #750fb4)',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #600896d2, #600896d2)',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
  },
}));
